/**
 * Per-account Stripe BYOK (Account Admin → Connect Stripe).
 */
import { getAuthHeaders } from './authHeaders';

const uiConfig = require('../../uiConfig');

const serverUrl = () => uiConfig.serverInfo.serverUrl;

/**
 * @param {{ accountId: string }} opts
 */
export async function getStripeConnectionStatus({ accountId } = {}) {
  const headers = await getAuthHeaders();
  const resp = await fetch(serverUrl() + '/stripeConnection/status', {
    method: 'POST',
    headers,
    body: JSON.stringify({ account_id: accountId }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || data.message || 'Unable to load Stripe connection status.');
  }
  return data;
}

/**
 * @param {{ accountId: string, secretKey?: string, publishableKey?: string, webhookSecret?: string, defaultCurrency?: string }} opts
 */
export async function saveStripeConnection({
  accountId,
  secretKey,
  publishableKey,
  webhookSecret,
  defaultCurrency,
} = {}) {
  const headers = await getAuthHeaders();
  const body = {
    secret_key: secretKey,
    publishable_key: publishableKey,
    webhook_secret: webhookSecret,
    default_currency: defaultCurrency,
  };
  body.account_id = accountId;
  const resp = await fetch(serverUrl() + '/stripeConnection/save', {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || data.message || 'Unable to save Stripe connection.');
  }
  return data;
}

/**
 * @param {{ accountId: string }} opts
 */
export async function disconnectStripeConnection({ accountId } = {}) {
  const headers = await getAuthHeaders();
  const resp = await fetch(serverUrl() + '/stripeConnection/disconnect', {
    method: 'POST',
    headers,
    body: JSON.stringify({ account_id: accountId }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.error || data.message || 'Unable to disconnect Stripe.');
  }
  return data;
}

/** Webhook endpoint URL for a StripeConnection account id. */
export function stripeWebhookUrlForAccount(connectionAccountId) {
  const base = String(serverUrl() || '').replace(/\/$/, '');
  const aid = connectionAccountId != null ? String(connectionAccountId).trim() : '';
  if (!base || !aid) return '';
  return `${base}/stripe/webhook/${encodeURIComponent(aid)}`;
}
